import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, ComponentSync, LL_H_C, ModuleFE_MouseInteractivity, mouseInteractivity_PopUp } from '@nu-art/thunderstorm-frontend/index';
import './PopUp_Confirmation.scss';
export class PopUp_Confirmation extends ComponentSync {
    //######################### Static ##########################
    static show = (e, props) => {
        // @ts-ignore - Don't know why TS says getBoundingClientRect doesn't exist here, it does
        const rect = e.target.getBoundingClientRect();
        const model = {
            content: () => _jsx(PopUp_Confirmation, { ...props }),
            id: 'pop-up__confirmation',
            modalPos: { x: -1, y: 0 },
            originPos: { x: rect.left, y: (rect.top + rect.height / 2) },
            overlayClass: 'pop-up-overlay__confirmation'
        };
        ModuleFE_MouseInteractivity.showContent(model);
    };
    //######################### Life Cycle ##########################
    deriveStateFromProps(nextProps, state) {
        state.message = nextProps.message;
        return state;
    }
    //######################### Logic ##########################
    onCancel = () => {
        ModuleFE_MouseInteractivity.hide(mouseInteractivity_PopUp);
    };
    onAccept = async () => {
        await this.props.onAccept();
        ModuleFE_MouseInteractivity.hide(mouseInteractivity_PopUp);
    };
    //######################### Render ##########################
    render() {
        return _jsxs(_Fragment, { children: [_jsx("div", { className: 'pop-up__confirmation__message', children: this.state.message }), this.render_Buttons()] });
    }
    render_Buttons = () => {
        return _jsxs(LL_H_C, { className: 'pop-up__confirmation__buttons', children: [_jsx(Button, { onClick: this.onCancel, variant: 'secondary', children: "Cancel" }), _jsx(Button, { onClick: this.onAccept, variant: 'primary', children: this.props.acceptButtonLabel ?? 'Accept' })] });
    };
}
//# sourceMappingURL=PopUp_Confirmation.js.map